<template>
  <div class="prizes-section"
    :class="{
      'prizes-section--side-by-side': !smallDisplay
    }"
    >
    <div class="section__content-wrapper prizes-section__content" v-if="!smallDisplay">
      <div class="prizes-section__left">
        <div class="prizes-section__main">
          <h2 class="prizes-section__title">
            {{headline}}
          </h2>
          <p class="prizes-section__copy">
            {{body}}
          </p>
        </div>
        <PrizeList class="prizes-section__prize-list" :activeIndex="activeIndex" @click="changeSlideIndex" />
      </div>
      <div class="prizes-section__right">
        <PrizeCarousel
          class="prizes-section__prize-carousel"
          @slideChange="updateSlideIndex"
          :images="prizeImages.desktop"
          :listIndex="listIndex"
          @busy="handleBusy"
        />
      </div>
    </div>
    <div class="section__content-wrapper prizes-section__content" v-if="smallDisplay">
      <div class="prizes-section__main">
        <h2 class="prizes-section__title">
          {{headline}}
        </h2>
        <p class="prizes-section__copy">
          {{body}}
        </p>
      </div>
      <PrizeCarousel
        class="prizes-section__prize-carousel"
        @slideChange="updateSlideIndex"
        :smallDisplay="smallDisplay"
        :images="prizeImages.mobile"
        :listIndex="listIndex"
        @busy="handleBusy"
      />
      <PrizeList
        class="prizes-section__prize-list"
        :activeIndex="activeIndex"
        :smallDisplay="smallDisplay"
        @click="changeSlideIndex"
      />
    </div>
  </div>
</template>

<script>
/**
 * Contest Prizes Section.
 */
import { mapState } from 'vuex';
import PrizeCarousel from './../components/prize-carousel';
import PrizeList from './../components/prize-list';
import { prizeImages } from './../core/image-config';
import { CONTENT_PRIZE_SECTION_HEADLINE, CONTENT_PRIZE_SECTION_BODY } from '../../design-tokens/build/dictionary';
import { GLOBAL_MEDIA } from '../core/utils';

export default {
  name: 'prizes',
  components: {
    PrizeCarousel,
    PrizeList,
  },
  data() {
    return {
      activeIndex: 0,
      listIndex: 0,
      headline: CONTENT_PRIZE_SECTION_HEADLINE,
      body: CONTENT_PRIZE_SECTION_BODY,
      smallDisplay: false,
      busy: false,
      mql: {
        sideBySide: window.matchMedia(GLOBAL_MEDIA['large-prizes'])
      },
      prizeImages,
    };
  },
  created() {
    this.mql.sideBySide.addListener(this.setSmallDisplay);
    this.setSmallDisplay(this.mql.sideBySide);
  },
  computed: {
    ...mapState('windowMedia', [
      'mediaMedium',
      'mediaSmall',
      'mediaLarge',
      'mediaXlarge',
    ])
  },
  methods: {
    updateSlideIndex(index) {
      this.activeIndex = index;
      this.listIndex = index;
    },
    changeSlideIndex(index) {
      if (this.busy) {
        return;
      }
      this.listIndex = index;
    },
    handleBusy(busy) {
      this.busy = busy;
    },
    setSmallDisplay({ matches }) {
      if (matches) {
        this.smallDisplay = false;
        return;
      }

      this.smallDisplay = true;
    }
  },
};
</script>

<style lang="scss">
.prizes-section {
  text-align: center;
  position: relative;
  margin: $size-margin-top-prizes-section-large 0 $size-margin-bottom-prizes-section-large;
  padding: $size-padding-top-prizes-section-large 0 $size-padding-bottom-prizes-section-large;
  @include media(small) {
    margin: $size-margin-top-prizes-section-small 0 $size-margin-bottom-prizes-section-small;
    padding: $size-padding-top-prizes-section-small 0 $size-padding-bottom-prizes-section-small;
  }

  &__main {

  }

  &__title {
    @include heading-2;
  }

  &__copy {
    @include body-copy-regular;

    margin: $size-margin-top-prizes-section-copy-small 0 $size-margin-bottom-prizes-section-copy-small;
  }

   &__prize-list {
    margin-top: $size-margin-top-prize-carousel-prize-list-small;
  }

  &--side-by-side {
    text-align: left;
    .section__content-wrapper {
      display: flex;
      justify-content: space-between;
    }

    .prizes-section {
      &__main {
        margin-right: $size-margin-prize-indicator;
      }
      &__copy {
        margin: $size-margin-top-prizes-section-copy-large 0 $size-margin-bottom-prizes-section-copy-large;
        max-width: percentage($size-width-prizes-section-copy-large / $size-width-prizes-section-left-large);
      }
      &__prize-list {
        margin: $size-margin-top-prize-carousel-prize-list-large 0 0 0;
      }
      &__left {
        @include grid-block($columns: 5);
        padding-right: percentage(precision($grid-gutter-width / 2));

        @include global-media('small') {
          padding-right: percentage(precision($grid-gutter-width-small / 2));
        }
        @include global-media('medium') {
          padding-right: percentage(precision($grid-gutter-width-medium / 2));
        }
      }
      &__right {
        flex: 1 1 auto;
      }
    }
  }
}
</style>
